module.exports = __webpack_public_path__ + "static/media/air-conditioner-cold.92a3aa79.png";